/* eslint-disable */
enum ButtonVariants {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
}
/* eslint-enable */
export default ButtonVariants
